import { useContext } from 'react'

import { NotificationContext } from 'contexts/notification'

function useNotification() {
  const { showNotification } = useContext(NotificationContext)

  return showNotification
}

export default useNotification
